/* ps-product.js — gallery, variant matrix and subscription pricing.
   The chips and plan rows are a skin over Shopify's real data: every click
   resolves a real variant id (and selling plan id) into the form's hidden
   inputs, and the gallery follows the flavour the shopper just picked. */
(function () {
  'use strict';

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    return format ? format.replace(/\{\{\s*\w+\s*\}\}/, v) : v;
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function initPdp(root) {
    var mainImage = root.querySelector('.ps-pdp__main img');
    var thumbs = [].slice.call(root.querySelectorAll('[data-ps-thumb]'));
    var media = parseJSON(root.querySelector('[data-ps-media]')) || {};

    var active = (function () {
      var cur = thumbs.filter(function (t) { return t.getAttribute('aria-current') === 'true'; })[0];
      return cur ? String(cur.dataset.psMediaId) : null;
    })();

    function showMedia(id) {
      if (!id) return;
      id = String(id);
      if (id === active) return;
      var m = media[id];
      if (m && mainImage) {
        mainImage.setAttribute('src', m.s);
        mainImage.setAttribute('srcset', m.t + ' 700w, ' + m.s + ' 1200w');
        mainImage.setAttribute('alt', m.a || '');
      }
      active = id;
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(t.dataset.psMediaId) === id ? 'true' : 'false');
      });
    }

    var dataEl = root.querySelector('[data-ps-variants]');
    var form = root.querySelector('form[data-ps-cart-form]') || root.querySelector('form[action*="/cart/add"]');
    var variants = parseJSON(dataEl);
    if (!variants || !variants.length || !form) return;
    if (!form.hasAttribute('data-ps-cart-form')) form.setAttribute('data-ps-cart-form', '');

    // Shopify stores one image per variant, and on this product they are
    // assigned by the first option — so every "Chocolate / X" variant carries
    // the Chocolate photo. Reading option 1 back out gives a flavour-name to
    // image map, which lets the SECOND flavour drive the gallery too.
    var flavourMedia = {};
    variants.forEach(function (v) {
      var name = v.o[0];
      if (v.m && name && !flavourMedia[name]) flavourMedia[name] = v.m;
    });

    var format = root.dataset.psMoneyFormat || '';
    var idInput = form.querySelector('[name="id"]');
    var planInput = form.querySelector('[name="selling_plan"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var groups = [].slice.call(root.querySelectorAll('[data-ps-option]'));
    var selected = groups.map(function (g) { return g.dataset.psSelected || ''; });

    // The image the shopper last asked for, by picking a flavour or a
    // thumbnail. Null means "follow the variant".
    var preferred = null;

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-ps-thumb]');
      if (!thumb) return;
      e.preventDefault();
      preferred = thumb.dataset.psMediaId;
      showMedia(preferred);
    });

    function find(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (v.o[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function offered(index, value) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.a || v.o[index] !== value) continue;
        var ok = true;
        for (var j = 0; j < selected.length; j++) {
          if (j !== index && v.o[j] !== selected[j]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function currentPlan() {
      var on = root.querySelector('[data-ps-plan][aria-pressed="true"]');
      return on ? (on.dataset.psPlan || '') : '';
    }

    function render() {
      var variant = groups.length ? find(selected) : variants[0];

      groups.forEach(function (group, index) {
        var readout = group.querySelector('[data-ps-option-value]');
        if (readout) readout.textContent = selected[index];
        group.querySelectorAll('[data-ps-chip]').forEach(function (chip) {
          chip.setAttribute('aria-pressed', chip.dataset.psChip === selected[index] ? 'true' : 'false');
          chip.setAttribute('data-unavailable', offered(index, chip.dataset.psChip) ? 'false' : 'true');
        });
      });

      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var planId = currentPlan();
      var compareEl = root.querySelector('[data-ps-compare]');

      document.querySelectorAll('[data-ps-variant-summary]').forEach(function (el) {
        el.textContent = groups.length ? selected.join(' + ') : '';
      });

      if (!variant) {
        document.querySelectorAll('[data-ps-submit]').forEach(function (btn) {
          btn.disabled = true;
          btn.textContent = btn.dataset.psLabelUnavailable || 'Unavailable combination';
        });
        return;
      }

      // A flavour the shopper picked wins; otherwise fall back to the
      // variant's own image. Flavours with no image leave the gallery as-is.
      showMedia(preferred || variant.m);

      var sp = variant.sp || {};

      root.querySelectorAll('[data-ps-plan-price]').forEach(function (el) {
        var key = el.dataset.psPlanPrice;
        var cents = key === 'once' ? variant.p : sp[key];
        if (cents != null) el.textContent = money(cents, format);
      });

      var unit = (planId && sp[planId] != null) ? sp[planId] : variant.p;

      if (idInput) idInput.value = variant.id;
      if (planInput) planInput.value = planId;

      document.querySelectorAll('[data-ps-price]').forEach(function (el) {
        el.textContent = money(unit, format);
      });
      document.querySelectorAll('[data-ps-line-total]').forEach(function (el) {
        el.textContent = money(unit * qty, format);
      });

      if (compareEl) {
        var was = (planId && sp[planId] != null) ? variant.p : variant.c;
        if (was && was > unit) {
          compareEl.textContent = money(was, format);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      document.querySelectorAll('[data-ps-submit]').forEach(function (btn) {
        btn.disabled = !variant.a;
        var label = variant.a ? (btn.dataset.psLabelIn || 'Add to cart') : (btn.dataset.psLabelOut || 'Sold out');
        var showPrice = btn.dataset.psShowPrice === 'true' && variant.a;
        btn.textContent = showPrice ? label + ' — ' + money(unit * qty, format) : label;
      });

      if (window.history && history.replaceState && groups.length) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        } catch (e) { /* older browsers: skip the URL sync */ }
      }
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ps-chip]');
      if (chip) {
        e.preventDefault();
        var group = chip.closest('[data-ps-option]');
        var index = groups.indexOf(group);
        if (index < 0) return;
        var value = chip.dataset.psChip;
        selected[index] = value;
        group.dataset.psSelected = value;
        // Whichever flavour was just picked owns the gallery, first or second.
        preferred = flavourMedia[value] || null;
        render();
        return;
      }

      var plan = e.target.closest('[data-ps-plan]');
      if (plan) {
        e.preventDefault();
        root.querySelectorAll('[data-ps-plan]').forEach(function (p) {
          p.setAttribute('aria-pressed', p === plan ? 'true' : 'false');
        });
        var note = root.querySelector('[data-ps-plan-note]');
        if (note && plan.dataset.psNote) note.textContent = plan.dataset.psNote;
        render();
      }
    });

    if (qtyInput) qtyInput.addEventListener('change', render);

    render();
  }

  // The sticky bar submits the one real product form rather than posting its own.
  document.addEventListener('click', function (e) {
    var proxy = e.target.closest('[data-ps-sticky-submit]');
    if (!proxy) return;
    e.preventDefault();
    var form = document.querySelector('form[data-ps-cart-form]');
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  function boot() {
    document.querySelectorAll('[data-ps-pdp]').forEach(function (root) {
      if (root.dataset.psBooted === 'true') return;
      root.dataset.psBooted = 'true';
      initPdp(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
